(function (angular) {

    angular.module('shared').directive('nfThumbnail', function () {
        return {
            restrict: 'E',
            templateUrl: 'js/shared/directives/thumbnail/thumbnail.html',
            scope: {
                src: '='
            }
        };
    });
}(angular));

angular.module('shared').directive('nfImageLoad', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            scope.$watch(attrs.nfImageSrc, function (newSrc) {
                if (newSrc) {
                    //reset
                    elem.attr("src", '');
                    elem.show();
                    elem.parent().find('md-icon').hide();


                    var fn = $parse(attrs.nfImageLoad);
                    elem.one("load", function (event) {
                        safeApply(function () {
                            fn(scope, {$event: event});
                        });
                    });

                    elem.one("error", function (error) {
                       elem.hide();
                       elem.parent().find('md-icon').show();
                    });
                    elem.attr("src", newSrc);
                }
            })

            function safeApply(fn) {
                var phase = scope.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    scope.$apply(fn);
                }

            }

        }
    };
}]);
